import { EmptyArray } from "../domain/empty/model";
import { SpendRepositoryImplementation } from '../infrastructure/spend-repository-implementation';
import { Spend } from '../domain/spend/model';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new SpendRepositoryImplementation();
const CACHE_PREFIX = 'spend';

async function createSpend(data: Partial<Spend>) {
  try {
    const result = await repo.createSpend(data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * Crea el gasto y emite el Documento Soporte DIAN en una sola llamada atómica.
 * Si la DIAN rechaza el documento, el gasto NO queda guardado (rollback en BD).
 */
async function createSpendWithSupportDocument(data: Partial<Spend>) {
  try {
    const result = await repo.createSpendWithSupportDocument(data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getSpend(id: number) {
  try {
    const cacheKey = `${CACHE_PREFIX}-detail-${id}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
      console.log(`Returning spend with ID ${id} from cache`);
      return cached;
    }

    const result = await repo.getSpend(id).toPromise();
    const data = result.data;
    if (data === null) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getSpends(page: number, limit: number) {
  try {
    const cacheKey = `${CACHE_PREFIX}-list-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
      console.log(`Returning spends for page ${page} from cache`);
      return cached;
    }

    const result = await repo.getSpends(page, limit).toPromise();
    const data = result.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function updateSpend(id: number, data: Partial<Spend>) {
  try {
    const result = await repo.updateSpend(id, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function deleteSpend(id: number) {
  try {
    await repo.deleteSpend(id).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export {
  createSpend,
  createSpendWithSupportDocument,
  getSpend,
  getSpends,
  updateSpend,
  deleteSpend,
};
